import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ChangeFunction} from '../types'

const QueryKey = 'config-functions'

type UseChangeFunctionsParams = {
  language?: string
  options?: Omit<UseQueryOptions<ChangeFunction[], AxiosError>, 'queryKey'>
}

export const useChangeFunctions = ({
  language = 'en-US',
  options
}: UseChangeFunctionsParams = {}) => {
  const path = '/shifthandover/change-functions'

  return useQuery<ChangeFunction[], AxiosError>({
    queryKey: [QueryKey, language],
    queryFn: async () => {
      const {data} = await ApiClient.axiosInstance.get<ChangeFunction[]>(path)
      return data
    },
    ...options
  })
}
